import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Moon } from "lucide-react";
import { api } from "@/lib/api";
import { primeStoryAudio } from "@/lib/storyAudio";

// Home card after 8pm (member's time) until tonight's wind-down is done
export const WindDownCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/bedtime/status", { params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone } }).then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s?.evening || s.tonight_done) return null;
  return (
    <div className="mb-6 rounded-3xl p-5 flex flex-wrap items-center gap-4 mm-fade-up" style={{ background: "#141A33", color: "#F4E9D8" }} data-testid="home-winddown-card">
      <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center shrink-0"><Moon size={22} style={{ color: "#F3C98B" }} /></div>
      <div className="flex-1 min-w-[12rem]">
        <div className="font-semibold">Ready to wind down?</div>
        <div className="text-sm opacity-70">Park a worry, one good thing, slow breathing, then a sleep story.</div>
      </div>
      <div className="flex gap-2 shrink-0">
        {s.favorites > 0 && (
          <Link to="/bedtime?play=favorite" onClick={primeStoryAudio} className="rounded-full text-sm font-semibold px-4 py-2 bg-white/10 hover:bg-white/15 flex items-center gap-1.5 transition-colors" data-testid="home-winddown-play-favorite">
            <Heart size={14} className="fill-[#F28FAD] text-[#F28FAD]" />Play my favorite
          </Link>
        )}
        <Link to="/bedtime" className="rounded-full text-sm font-semibold px-4 py-2 hover:-translate-y-0.5 transition-transform" style={{ background: "#F3C98B", color: "#141A33" }} data-testid="home-winddown-begin">Begin</Link>
      </div>
    </div>
  );
};
